// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MenuItemsQueryVariables = Types.Exact<{
  filter: Types.CasinoMenuItemConnectionFilter;
  sort: Types.CasinoMenuItemConnectionSorter;
  menuItemGamesFilter: Types.CasinoNodeGamesConnectionFilter;
}>;


export type MenuItemsQuery = { __typename?: 'Query', casino?: { __typename?: 'Casino', id: string, menuItems?: { __typename?: 'CasinoMenuItemConnection', edges?: Array<{ __typename?: 'CasinoMenuItemEdge', node?: { __typename?: 'CasinoMenuItem', name?: string, handle?: string, games?: { __typename?: 'CasinoGameConnection', totalCount?: number } } }> } } };


export const MenuItemsQueryDocument = /*#__PURE__*/ gql`
    query MenuItemsQuery($filter: CasinoMenuItemConnectionFilter!, $sort: CasinoMenuItemConnectionSorter!, $menuItemGamesFilter: CasinoNodeGamesConnectionFilter!) {
  casino {
    id
    menuItems(sort: $sort, filter: $filter) {
      edges {
        node {
          name
          handle
          games(filter: $menuItemGamesFilter) {
            totalCount
          }
        }
      }
    }
  }
}
    `;
export function useMenuItemsQuery(baseOptions: Apollo.QueryHookOptions<MenuItemsQuery, MenuItemsQueryVariables> & ({ variables: MenuItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenuItemsQuery, MenuItemsQueryVariables>(MenuItemsQueryDocument, options);
      }
export function useMenuItemsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenuItemsQuery, MenuItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenuItemsQuery, MenuItemsQueryVariables>(MenuItemsQueryDocument, options);
        }
export function useMenuItemsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MenuItemsQuery, MenuItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MenuItemsQuery, MenuItemsQueryVariables>(MenuItemsQueryDocument, options);
        }
export type MenuItemsQueryHookResult = ReturnType<typeof useMenuItemsQuery>;
export type MenuItemsQueryLazyQueryHookResult = ReturnType<typeof useMenuItemsQueryLazyQuery>;
export type MenuItemsQuerySuspenseQueryHookResult = ReturnType<typeof useMenuItemsQuerySuspenseQuery>;
export type MenuItemsQueryQueryResult = Apollo.QueryResult<MenuItemsQuery, MenuItemsQueryVariables>;